import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, FormHelperText, Grid, Icon } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label.js";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import { getSupportCreate, resetSupportActionState } from "../../store/actions.js";
import CustomTextField from "../../components/Form/CustomTextField.js";
import UploadProductImagesNew from "../../components/Form/UploadProductImagesNew.js";
import CustomButton from "../../components/Form/CustomButton.js";

const CreateSupport = ({ userPermission, leftSideBarType, addSupport, layoutWidth, error }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        setIsSubmitted(false);
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [formObj, setFormObj] = useState({});
    const [uploadFiles, setUploadFiles] = useState([]);
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', bannerType: 'all' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("10");
    const [search, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("start");
    const [selectedRow, setSelectedRow] = useState();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(true);
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [width, setWidth] = useState(window.innerWidth);
    const searchRef = useRef(search);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
        }
    }, [userPermission]);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (addSupport?.code === 'success') {
            setIsLoading(false);
            setIsSubmitted(true);
            dispatch(resetSupportActionState());
            setNotification({
                open: true,
                msg: addSupport?.message || "Support request submitted successfully",
                type: "success",
            })
        } else if (addSupport?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: addSupport?.message || "Invalid Fields",
                type: "error",
            })
            // dispatch(resetSupportActionState());
        }
    }, [addSupport])

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by, filterObject]);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (checkedAll) {
            // let temp = vendorsListing && vendorsListing?.data?.length > 0 ? vendorsListing?.data?.map((x, idx) => x?.id) : []
            // setSelectedRow(temp)
        } else {
            setSelectedRow("")
        }

    }, [checkedAll]);

    const initData = () => {
        // dispatch(getBannerListing({
        //     page: page,
        //     size: length,
        //     status: filterObject?.status,
        //     position: filterObject?.position,
        //     type: filterObject?.bannerType === 'all' ? '' : filterObject?.bannerType,
        //     sort: sort,
        //     sort_by: sort_by,
        //     search: name
        // }))
    }

    const handleSubmit = () => {
        setIsLoading(true);
        let payload = {
            email: formObj?.email,
            subject: formObj?.subject,
            issue: formObj?.message,
            attachments: uploadFiles?.map((file) => ({
                name: file?.file_name,
                file: file?.file_base64,
            })) || [],
        }
        dispatch(getSupportCreate(payload));
    }

    const handleFormChange = (key, value) => {
        setFormObj({
            ...formObj,
            [key]: value,
        });
    }

    const renderHeader = () => {
        return (
            <div className="px-1 pb-2">
                <div className="header-2">Need help? We’re here for you. </div>
                <div className="subheader-2">Submit your question, issue, or feedback and our support team will get back to you as soon as possible.</div>
            </div>
        )
    }

    const renderForm = () => {
        return (
            <Grid container spacing={2} pt={2}>
                <Grid item lg={7} md={7} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.email}
                        placeholder={'Email address'}
                        onChange={(e) => handleFormChange('email', e)}
                        error={error?.email}
                    />
                </Grid>
                <Grid item lg={7} md={7} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.subject}
                        placeholder={'Subject'}
                        onChange={(e) => handleFormChange('subject', e)}
                        error={error?.subject}
                    />
                </Grid>
                <Grid item lg={7} md={7} sm={12} xs={12}>
                    <CustomTextField
                        values={formObj?.message}
                        placeholder={'Tell us about your issue'}
                        onChange={(e) => {
                            const value = e;
                            if (value.length <= 1000) {
                                handleFormChange('message', e)
                            }
                        }}
                        multiline={true}
                        rows={6}
                        width={'100%'}
                        error={error?.issue}
                        subtitle={`${formObj?.message ? formObj?.message?.length : 0}/1000 characters`}
                    />
                </Grid>
                <Grid item lg={7} md={7} sm={12} xs={12}>
                    <UploadProductImagesNew
                        title={<div className="d-flex subheader-2"><div className="text-bold" style={{ color: '#1D1B1B', marginRight: 5 }}>Attachment</div><span className="optional-label me-2">Optional</span></div>}
                        showLimit={false}
                        values={uploadFiles}
                        setFormValues={(e) => setUploadFiles(e)}
                        images={true}
                        maxFile={10}
                        multiple={true}
                        setNotification={setNotification}
                        windowWidth={layoutWidth}
                        error={error}
                        errorName={"attachments"}
                    />

                </Grid>
                <Grid item lg={7} md={7} sm={12} xs={12}>
                    <CustomButton
                        title={'Send'}
                        press={() => handleSubmit()}
                    />
                </Grid>
            </Grid>
        )
    }

    const renderSendedNotification = () => {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ height: '60vh' }}>
                <div className="text-center">
                    <div className="header-2">Request submitted</div>
                    <div className="subheader-2 my-3">Your message has been received. We’ll get back to you via email soon.</div>
                    <CustomButton
                        title={'Back to dashboard'}
                        press={() => { navigate('/dashboard'); setIsSubmitted(false); }}
                    />
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {renderHeader()}
                    {isSubmitted ? renderSendedNotification() : renderForm()}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Support, Layout }) {
    return {
        userPermission: Login.permissionArry,
        addSupport: Support?.supportCreate,
        error: Support?.error?.errors,
        leftSideBarType: Layout?.leftSideBarType,
        layoutWidth: Layout.currentWidth
    };
}

export default connect(mapStateToProps)(CreateSupport);
